import TuppleRenderer from "@/components/srp/TuppleRenderer"
import { Container, Typography } from "@cleartrip/ct-design-components"
import { formatCurrency } from '../../../../../../utils/general/browserHelper';

export const PtcFareTopCallout = (query) => {
    return (
        <>
            <Container>
                <Typography className="py-4" variant="HM2">
                Showing results with {getSftName(query.query.sft)} fare
                </Typography>
               
            </Container>
        </>
    )
}

export const PtcTupleRenedrer = (props) => {
    const { searchQuery, cheapestFilteredFlight } = props
    const cheapestFlight = cheapestFilteredFlight[0] < cheapestFilteredFlight[1] ? cheapestFilteredFlight[0] : cheapestFilteredFlight[1]
    return (
        <>
            <TuppleRenderer {...props} />
            <RegularFareDivider fareType={getSftName(searchQuery.sft)} startingPrice={cheapestFlight} />
        </>
    )
}


export function RegularFareDivider(props) {
    const {isSpecialFareEmpty = false,fareType = '', startingPrice , isPerAdult = false , perAdultStartingRegularFare = 0} = props
    return (
        <>
            <div style={{ display: "flex", alignItems: "center",marginTop:isSpecialFareEmpty ? "0px" : "40px", marginLeft: "80px", marginRight: "80px", marginBottom: "56px" }}>
                <div style={{ flex: 1, backgroundColor: "#e6e6e6", height: "1px" }} />
                <p style={{ margin: "0 30px", color:'grey', fontSize:'16px' }}>That’s all for the {fareType} fare options!</p>
                <div style={{ flex: 1, backgroundColor: "#e6e6e6", height: "1px" }} />
            </div>
            <Typography variant="HM2" className="fs-6 fw-600 mb-8">Regular fare options {startingPrice!==0 ? `starting from ${formatCurrency(startingPrice)}`:'' } </Typography>
        </>
    )
}

export const RegularOptionsButton = (props) => {

    return (
        <>
            <div className="mt-8 mb-6" style={{ display: "flex", alignItems: "center" }}>
                <div style={{ flex: 1, backgroundColor: "#e6e6e6", height: "1px" }} />
                <p className='c-neutral-500 fs-2 fw-500' style={{ margin: "0 20px" }}>That’s all for the {props.from} → {props.to} {props.fareType} fare options!</p>
                <div style={{ flex: 1, backgroundColor: "#e6e6e6", height: "1px" }} />
            </div>
            <div className="flex flex-row flex-between pb-8 bb bc-neutral-100">
                <div className="fs-3 w-50p">Regular fare options available starting from {props.startingPrice}</div>
                <button onClick={()=>props.onClickViewRegular()} className="bc-secondary-500 c-secondary-500 br-4 h-10 bg-white fs-3 bw-1 fw-600" style={{ width: "152px" }}>View regular fares</button>
            </div>
        </>
    )
}


export function getSftName(sftFare) {
    switch (sftFare) {
        case 'senior_citizen':
            return 'Senior Citizen'
        case 'student':
            return 'Student'
        case 'army':
            return 'Army'
    }
}